import { Controller } from "@hotwired/stimulus"
const confetti = require('canvas-confetti');

// https://github.com/catdad/canvas-confetti
// https://www.kirilv.com/canvas-confetti/#continuous

export default class extends Controller {
  connect() {
    this.fire();
  }

  fire() {
    const SECONDS = 2;
    var COLORS = ['#5660FB', '#D3F5F4', '#FDDCDC', '#ffffff'];

    var end = Date.now() + (SECONDS * 1000);

    (function frame() {
      confetti({
        particleCount: 2,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors: COLORS
      });
      confetti({
        particleCount: 2,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: COLORS
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    }());
  }
}
